
import { Header } from "@/components/layout/Header";
import { useEffect } from "react";
import { LegalLinksGrid } from "@/components/settings/LegalLinksGrid";
import { Card, CardContent } from "@/components/ui/card";
import { Mail, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <Button
          variant="ghost"
          onClick={() => navigate("/dashboard")}
          className="mb-4"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Dashboard
        </Button>

        <div className="max-w-4xl">
          <h1 className="text-3xl font-bold mb-8">Contact Us</h1>
          
          <p className="text-gray-600 mb-8 text-lg">
            If you have any questions, suggestions, or need to report a problem, please reach out to us using the contact details provided. We're here to help and appreciate your feedback!
          </p>

          <Card>
            <CardContent className="pt-6 space-y-6">
              <div className="flex items-start gap-4">
                <Mail className="w-5 h-5 text-primary mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Email</h3>
                  <p className="text-gray-600">
                    info@brightstages.com
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12">
          <h2 className="text-2xl font-semibold mb-6">Legal Information</h2>
          <LegalLinksGrid />
        </div>
      </main>
    </div>
  );
};

export default ContactUs;
